/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useTipoCaja = (id_tamanio_envase) => {
  const token = localStorage.getItem("@Token");
  const [tipoCaja, setTipoCaja] = useState([]);
  const [isTipoCajaLoading, setIsTipoCajaLoading] = useState(false);

  const getTipoCaja = async () => {
    setIsTipoCajaLoading(true);
    try {
      const response = await api.get(
        `api/etiquetas/tipo_caja/?id_tamano_envase=${id_tamanio_envase}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      setTipoCaja(response.data);
    } catch (error) {
      setTipoCaja([]);
      console.log(error);
    } finally {
      setIsTipoCajaLoading(false);
    }
  };
  useEffect(() => {
    if (
      id_tamanio_envase !== 0 &&
      id_tamanio_envase !== "" &&
      id_tamanio_envase !== "0"
    ) {
      getTipoCaja();
    } else {
      setTipoCaja([]);
    }
  }, [id_tamanio_envase]);

  return { tipoCaja, getTipoCaja, isTipoCajaLoading };
};
